"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreMessages = void 0;
var StoreMessages;
(function (StoreMessages) {
    StoreMessages["STORE_INVALID_STORAGE"] = "Invalid storage";
    StoreMessages["STORE_ERROR_STRINGIFY"] = "To stringify data";
    StoreMessages["STORE_ERROR_PARSING"] = "To parsing string > data, it will clear the data on store!";
})(StoreMessages || (exports.StoreMessages = StoreMessages = {}));
//# sourceMappingURL=messages.js.map